import Vue from "vue";
import i18n from "./i18n";
import moment from "moment";
import "bootstrap/dist/css/bootstrap.min.css";
import "@fortawesome/fontawesome-free/css/all.min.css";
import "./styles/base.css";
import App from "./App.vue";
import { pausenplanHealth } from "./utils/pausenplanHealth";

//import axios from 'axios';
moment.locale(i18n.locale);

import Echo from "laravel-echo";
window.io = require("socket.io-client");

if (typeof window.io !== "undefined") {
  if (window.location.hostname.includes("localhost")) {
    window.Echo = new Echo({
      broadcaster: "socket.io",
      host: process.env.VUE_APP_ECHO_HOST || "localhost:6001"
    });
  } else {
    //web.meinelohnabrechnung.at
    window.Echo = new Echo({
      broadcaster: "socket.io",
      host: process.env.VUE_APP_ECHO_HOST || window.location.hostname
    });
  }
} else {
  console.log("window.io is undefined, can not use io-socket");
}

Vue.config.productionTip = false;

// Bounded RAM-only diagnostics, independent of the Vue render scheduler.
window.__pausenplanHealth = pausenplanHealth;
Vue.config.errorHandler = function(err, vm, info) {
  console.error("[Pausenplan] Vue error in " + info + ":", err);
  pausenplanHealth.error(err, info);
};

new Vue({
  i18n,
  render: (h) => h(App)
}).$mount("#app");
